
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiRequest, } from '../_helpers/apiConfig';



export const getAllWithdrawalList = createAsyncThunk("adminApi/userWithdrawalList", async (filters) => {
    const response = await apiRequest('POST', '/v1/adminApi/userWithdrawalList', filters);
    return response;
});

export const paymentModeUserWithdrawal = createAsyncThunk("adminApi/paymentModeUserWithdrawal", async (arg, thunkAPI) => {
    const { Payload, isRefresh } = arg;
    const response = await apiRequest('POST', '/v1/adminApi/paymentModeUserWithdrawal', Payload);
    if (response.message) {
        thunkAPI.dispatch(getAllWithdrawalList(isRefresh))
    }
    return response;
});

export const updateUserWithdrawalStatus = createAsyncThunk("adminApi/updateUserWithdrawalStatus", async (arg, thunkAPI) => {
    const { Payload, isRefresh } = arg;
    const response = await apiRequest('POST', '/v1/adminApi/updateUserWithdrawalStatus', Payload);
    if (response.message) {
        thunkAPI.dispatch(getAllWithdrawalList(isRefresh))
    }
    return response;
});

export const withdrawalList = createAsyncThunk("adminApi/withdrawalList", async (filters) => {
    const response = await apiRequest('POST', '/v1/adminApi/withdrawalList', filters);
    return response;
});

export const getTotalWithDrawData = createAsyncThunk("adminApi/getTotalWithDrawData", async () => {
    const response = await apiRequest('POST', '/v1/adminApi/getTotalWithDrawData', );
    return response;
});


const teachersWithdrawal = createSlice({
    name: 'teachersWithdrawal',
    initialState: {
        withdrawalListData: [],
        withdrawalListTotal: [],
        paymentModeUserWithdrawalData: [],
        updateUserWithdrawalStatusData: [],
        withdrawalListData1: [],
        withdrawalListTotal1: [],
        getTotalWithDrawDataData: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllWithdrawalList.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAllWithdrawalList.fulfilled, (state, action) => {
                state.loading = false;
                state.withdrawalListData = action?.payload?.data?.list;
                state.withdrawalListTotal = action?.payload?.data?.total;

            })
            .addCase(getAllWithdrawalList.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            .addCase(paymentModeUserWithdrawal.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(paymentModeUserWithdrawal.fulfilled, (state, action) => {
                state.loading = false;
                state.paymentModeUserWithdrawalData = action?.payload;

            })
            .addCase(paymentModeUserWithdrawal.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            .addCase(updateUserWithdrawalStatus.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateUserWithdrawalStatus.fulfilled, (state, action) => {
                state.loading = false;
                state.updateUserWithdrawalStatusData = action?.payload;

            })
            .addCase(updateUserWithdrawalStatus.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            .addCase(withdrawalList.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(withdrawalList.fulfilled, (state, action) => {
                state.loading = false;
                state.withdrawalListData1 = action?.payload?.data?.list;
                state.withdrawalListTotal1 = action?.payload?.data?.total;

            })
            .addCase(withdrawalList.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            .addCase(getTotalWithDrawData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getTotalWithDrawData.fulfilled, (state, action) => {
                state.loading = false;
                state.getTotalWithDrawDataData = action?.payload?.data;

            })
            .addCase(getTotalWithDrawData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
    },
});

export default teachersWithdrawal.reducer;